import { STORE_KEY } from '../constants';

export type Store = {
    [key: string]: unknown;
};

// В веб-приложении мы не используем chrome.storage, поэтому определяем тип для совместимости
// Оставляем для совместимости с другими частями приложения
export type StoreUpdate = Record<string, unknown>;

const emptyStore: Store = {};

const getLocalStorage = (): Store | undefined => {
    const data = localStorage.getItem(STORE_KEY);

    if (!data) {
        return undefined;
    }

    try {
        return JSON.parse(data);
    } catch {
        return undefined;
    }
};

export const getStore = async (): Promise<Store> => {
    const store = getLocalStorage();

    if (!store) {
        return emptyStore;
    }

    return store;
};

export const setStore = async (store: Store): Promise<void> => {
    localStorage.setItem(STORE_KEY, JSON.stringify(store));
};

export const getStoreValue = async <T>(key: string): Promise<T> => {
    const store = await getStore();

    return store[key] as T;
};

export const setStoreValue = async <T>(key: string, value: T): Promise<void> => {
    const store = await getStore();

    const newStore: Store = {
        ...store,
        [key]: value,
    };

    await setStore(newStore);
};

export const initStore = async (): Promise<Store> => {
    const store = await getStore();

    const initialStore: Store = {
        ...emptyStore,
        ...store,
    };

    await setStore(initialStore);

    return initialStore;
};
